module.exports = __webpack_public_path__ + "static/low-rate-card-w-illustrations-f2d1d8653ca859fffb981de88b2208b3.png";